export default 'counterExample'
